import React from "react";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { TodoCreateNavigator } from "./TodoCreateNavigator";

import { useTheme } from "arkh";

import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { TodoCreateMainNew } from "./TodoCreateMainNew";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { TodoCreateLinkProduct } from "./TodoCreateLinkProduct";
import { TodoCreateStateProvider } from "./TodoCreateState";

export const TodoCreateScreen = withWebModal(TodoCreateScreenC);
function TodoCreateScreenC({
  route,
}: UserLoggedInNavigatorScreenProps<"TodoCreate">) {
  const theme = useTheme();
  const intl_tokens = useIntlTokens();

  const navigationHeaderOptions = useNavigationHeaderOptions();

  return (
    <TodoCreateStateProvider
      initialEmployeeIds={
        route.params.initialAssignedToMe
          ? [route.params.initialAssignedToMe]
          : undefined
      }
      initialTeamIds={
        route.params.teamIds ? [...route.params.teamIds] : undefined
      }
      initialProductIds={
        route.params.productIds ? [...route.params.productIds] : undefined
      }
    >
      <TodoCreateNavigator.Navigator
        screenOptions={{
          contentStyle: {
            backgroundColor: theme["surface-background-light"],
          },
        }}
      >
        <TodoCreateNavigator.Screen
          name="Main"
          initialParams={{
            categoryId: route.params.categoryId,
            connectionId: route.params.connectionId,
            assignedToMeConnectionId: route.params.assignedToMeConnectionId,
          }}
          options={({ navigation }) =>
            navigationHeaderOptions({
              type: "CREATE-INIT",
              onCancel: () => {
                navigation.goBack();
              },
              defaultContentStyle: true,
            })
          }
          component={TodoCreateMainNew}
        />

        <TodoCreateNavigator.Screen
          name="TodoCreateLinkProduct"
          component={TodoCreateLinkProduct}
          options={({ route, navigation }) =>
            navigationHeaderOptions({
              type: "DONE",
              onDone: () => {
                navigation.goBack();
              },
              title: intl_tokens.Products,
            })
          }
        />
      </TodoCreateNavigator.Navigator>
    </TodoCreateStateProvider>
  );
}
